import React from 'react'
import '../assets/css/allRecipes.css'

import { Link } from 'react-router-dom'

export default function AllRecipes(props) {
    const recipesSection = props.data;
  return (
    <div className="AllRecipes">
    <div className="d-flex recipesHeight flex-wrap">
      {recipesSection.map((recipe, index) => (
        <div className={`recipeCap w-${recipe.width}`} key={index}>
          <Link to={`/recipe/${recipe.id}`}>
            <div className="image-container w-100">
              <img src={recipe.image} alt={`Recipe ${index + 1}`} />
            </div>
            <div className="recipeCaption">
              <div className="captionTitle">
                <div className="RecipeTitle">{recipe.title}</div>
              </div>
            <div className="captionBody">{recipe.caption}</div>
          </div>
          </Link>
        </div>
      ))}
    </div>
  </div>
  )
}
